import { ApiEndpoint } from "./types";

const RESOURCE_HUB_HOST = `${process.env.GATSBY_APP_API_ROOT}/api/resource-hub/search`;
const RESOURCE_HUB_AUTOCOMPLETE_HOST = `${process.env.GATSBY_APP_API_ROOT}/api/resource-hub/autocomplete`;
const SCR_HOST = `${process.env.GATSBY_APP_API_ROOT}/api/scr/`;
const SCR_SCHEMES_HOST = `${process.env.GATSBY_APP_API_ROOT}/api/scr-schemes`;
const ORGANIZATIONS_HOST = `${process.env.GATSBY_APP_API_ROOT}/api/organizations`;
const COUNTRIES_HOST = `${process.env.GATSBY_APP_API_ROOT}/api/countries`;
const FORM_SUBMISSIONS_HOST = `${process.env.GATSBY_APP_API_ROOT}/api/form-submission`;

export enum ApiMethod {
  GET = "get",
  POST = "post",
  PUT = "put",
}

export const API = {
  // RESOURCE HUB
  GET_RESOURCE_HUB: (params?: Record<string, any>): ApiEndpoint => ({
    method: ApiMethod.GET,
    url: `${RESOURCE_HUB_HOST}`,
    params,
  }),
  // RESOURCE HUB AUTOCOMPLETE
  GET_RESOURCE_HUB_AUTOCOMPLETE: (params?: Record<string, any>): ApiEndpoint => ({
    method: ApiMethod.GET,
    url: `${RESOURCE_HUB_AUTOCOMPLETE_HOST}`,
    params,
  }),
  // SCR
  GET_SCR: (params?: Record<string, any>): ApiEndpoint => ({
    method: ApiMethod.GET,
    url: `${SCR_HOST}`,
    params,
  }),
  // SCR SCHEMES
  GET_SCR_SCHEMES: (params?: Record<string, any>): ApiEndpoint => ({
    method: ApiMethod.GET,
    url: `${SCR_SCHEMES_HOST}`,
    params,
  }),
  // ORGANIZATIONS (ATO & ACP)
  GET_ORGANIZATIONS: (params?: Record<string, any>): ApiEndpoint => ({
    method: ApiMethod.GET,
    url: `${ORGANIZATIONS_HOST}`,
    params,
  }),
  // COUNTRIES (ATO & ACP)
  GET_COUNTRIES: (params?: Record<string, any>): ApiEndpoint => ({
    method: ApiMethod.GET,
    url: `${COUNTRIES_HOST}`,
    params,
  }),
  // FORM SUBMISSIONS
  POST_FORM_SUBMISSIONS: (request?: Record<string, any>): ApiEndpoint => ({
    method: ApiMethod.POST,
    url: `${FORM_SUBMISSIONS_HOST}`,
    data: request,
  }),
};
